module.exports = __webpack_public_path__ + "img/327.b4ec2261.jpg";